import { render } from "./OneButton.vue?vue&type=template&id=6f7aacb8&scoped=true"
import script from "./OneButton.vue?vue&type=script&lang=js"
export * from "./OneButton.vue?vue&type=script&lang=js"

import "./OneButton.vue?vue&type=style&index=0&id=6f7aacb8&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7aacb8"]])

export default __exports__